enum testIds {
	externalListActionComponent = 'external-links',
}

export default testIds;
